class MapMultipleMarker extends BaseMap {
	constructor(options) {
        options.positionNoSelf = true;
		super(options);
	}

	getUrlVars() {
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}

	mapRdy(){
		if(this.options.all){
			var currentPage = this.getUrlVars()['page'];
			if(currentPage === undefined){
				currentPage = '1';
			}

			let options = {
				method: 'GET',
                url: SETTINGS.BASE_URL + 'service/search/branch?page='+ currentPage +'&lang=' + SETTINGS.LANGUAGE,
				dataType: 'json',
				success: $.proxy(this.ajaxSuccess, this),
				error: $.proxy(this.ajaxError, this)
			};

			$.ajax(options);
		}
	}

	addEvents() {
		Me.dispatch.subscribe('update.restaurant.list', (e, params) => this.updateMaps(e,params));
	}

	removeEvents() {
		Me.dispatch.unsubscribe('update.restaurant.list', (e, params) => this.updateMaps(e,params));
	}

	updateMaps(e, params){
		this.setPosition(params.position);

		if(!this.restaurants){
			this.restaurants = params.data;
		}

		this.setMarkers(this.restaurants);
	}

	ajaxSuccess(data){
		this.setMarkers(data);
	}

	ajaxError(error){
		console.log(error);
	}
}
